var collectionOrder = require("../../uat/src/elements/ua.collection.order.js");

module.exports = async function(context) {
  if (!(collectionOrder && typeof collectionOrder.init === "function")) return;
  await collectionOrder.init(context || {});
};
